;(function($, window, document, undefined) {
  'use strict';
  var map;

  var mapstyles = [
      {
          "featureType": "water",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "simplified"
              },
              {
                  "hue": "#e9ebed"
              },
              {
                  "saturation": -78
              },
              {
                  "lightness": 67
              }
          ]
      },
      {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "simplified"
              },
              {
                  "hue": "#ffffff"
              },
              {
                  "saturation": -100
              },
              {
                  "lightness": 100
              }
          ]
      },
      {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
              {
                  "visibility": "simplified"
              },
              {
                  "hue": "#bbc0c4"
              },
              {
                  "saturation": -93
              },
              {
                  "lightness": 31
              }
          ]
      },
      {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "off"
              },
              {
                  "hue": "#ffffff"
              },
              {
                  "saturation": -100
              },
              {
                  "lightness": 100
              }
          ]
      },
      {
          "featureType": "road.local",
          "elementType": "geometry",
          "stylers": [
              {
                  "visibility": "simplified"
              },
              {
                  "hue": "#e9ebed"
              },
              {
                  "saturation": -90
              },
              {
                  "lightness": -8
              }
          ]
      },
      {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "on"
              },
              {
                  "hue": "#e9ebed"
              },
              {
                  "saturation": 10
              },
              {
                  "lightness": 69
              }
          ]
      },
      {
          "featureType": "administrative.locality",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "on"
              },
              {
                  "hue": "#2c2e33"
              },
              {
                  "saturation": 7
              },
              {
                  "lightness": 19
              }
          ]
      },
      {
          "featureType": "road",
          "elementType": "labels",
          "stylers": [
              {
                  "visibility": "on"
              },
              {
                  "hue": "#bbc0c4"
              },
              {
                  "saturation": -93
              },
              {
                  "lightness": 31
              }
          ]
      },
      {
          "featureType": "road.arterial",
          "elementType": "labels",
          "stylers": [
              {
                  "visibility": "simplified"
              },
              {
                  "hue": "#bbc0c4"
              },
              {
                  "saturation": -93
              },
              {
                  "lightness": -2
              }
          ]
      }
  ]; // map styles

  // galvanize 40.0165447,-105.2838747
  var _lat = 40.0165447;
  var _long = -105.2838747;

  var latlng = new google.maps.LatLng(_lat,_long);
  // Map Options
  var myOptions = {
      zoom: 10,
      center: latlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      draggable: false, //true,
      scrollwheel: false, //true,
      // Google Map Color Styles
      styles: mapstyles
  };

  $(document).ready(function() {
    map = new google.maps.Map(document.getElementById('google-map'), myOptions);

    //google.maps.event.addDomListener(window, 'load', initialize);
    google.maps.event.addDomListener(window, "resize", function() {
     var center = map.getCenter();
     google.maps.event.trigger(map, "resize");
     map.setCenter(center); 
    });

    var infowindow = new google.maps.InfoWindow({
      content: '<h5><strong>Relish Studio @ Galvanize</strong></h5><p><small>Attn: Relish Studio<br/>1023 Walnut Street<br/>Boulder, CO 80302l</small><br/><a href="https://www.google.com/maps?q=1023+Walnut+StreetBoulder,+CO+80302&entry=gmail&source=g" target="_blank"><small>Directions</small></a></p>'
    });
    var image = 'https://relishstudio.com/wp-content/uploads/2017/04/r-point.png';
    // var image = '//relishstudio.com/rslabs/2015widgets/r-point.png';
    var relishlatlong = [_lat, _long]; // ['39.765056','-104.986436'];
    var relishpoint = new google.maps.LatLng(relishlatlong[0],relishlatlong[1]);
    var marker = new google.maps.Marker({
          position: relishpoint,
          map: map,
          // title: '<h5>Relish Studio</h5><p>Industry<br/>3001 Brighton Blvd., Suite 521<br/>Denver CO, 80216</p>',
          title: 'Relish Studio Headquarters',
          icon: image
      }); 
    marker.addListener('click', function() {
      infowindow.open(map, marker);
    });
      // google.maps.event.addListener(marker, 'click', function() {
      //     infowindow.setContent(this.title);
      //     infowindow.open(map, this);
      // });
    });


})( jQuery, window, document );
